import { defineStore } from "pinia";
import { rootGetters } from "@/main";


const endpoints = {
    getHistory: { method: "get", url: "/history/{entity_name}/{entity_id}/history" },
};


export const useHistoryStore = defineStore("history", {
    state: () => ({
        historyList: [],
    }),
    getters: {
        operationsMap() {
            return new Map<string, string>([
                ["INSERT", "Создание"],
                ["UPDATE", "Обновление"]
            ]);
        },
        fieldsMap() {
            return new Map<string, string>([
                ["brand_pk", "Бренд"],
                ["end_date", "Дата окончания"],
                ["start_date", "Дата начала"],
                ["extra_info", "Дата окончания"],
                ["is_archived", "Архив"],
                ['name', "Имя"],
                ['shop_id', "Магазин"],
                ['strategy', "Стратегия"],
                ['plan_impressions', "Показы план"],
                ['plan_click', "Клики план"],
                ['plan_reach', "Охват план"],
                ['plan_cost', "Бюджет план"],
                ['fname', "Имя"],
                ['lname', "Фамилия"],
                ['role_id', "Роль"],
                ['login', "Логин"],
                ['is_statistics_required', "Собирать статистику в SSP"],
                ['source_slug', "Источник"],
                ['patterns', "Паттерны"],
                ['is_platform', "Является платформой"],
                ['description', "Описание"],
                ['default_value', "Значение по умолчанию"],
                ['roles', "роль"],
                ['organizations', "организация"],
                ['departments', "департамент"],
            ]);
        },
        excludedFields() {
            return ['id', 'cuser_id', 'muser_id', 'ctime', 'mtime', 'tenant', 'transaction', 'is_deleted', 'department_id', 'organization_id'];
        },
        dateFields() {
            return ['start_date', 'end_date'];
        }
    },
    actions: {
        async getHistory(entity: string, entity_id: number | string) {
            await rootGetters.api.proceedRequest(
                endpoints.getHistory, { entity_id: entity_id, entity_name: entity }
            ).then((response) => {
                if (response.data)
                    this.historyList = response.data.versions;
            });
        },
        async getHistoryItems(entity: string, entity_id: number | string) {
            try {
                const response = await rootGetters.api.proceedRequest(
                    endpoints.getHistory, { entity_id: entity_id, entity_name: entity }
                );

                if (response.data) {
                    return response.data.versions;
                }
            } catch (error) {
                console.error("Error fetching history:", error);
            }
            return null;
        },
        async fetchAllHistories(entity: string, entity_ids: number[]) {
            const histories: any[] = [];

            const promises = entity_ids.map(async (e) => {
                const history = await this.getHistoryItems(entity, e);
                histories.push({ id: e, histories: history });
            });

            // Ожидание завершения всех промисов
            await Promise.all(promises);

            return histories;
        },
        async fetchAllHistoriesByEntity(entities: Entity[]) {
            const histories: any[] = [];

            // Основной массив промисов
            const promises = entities.map(async (e) => {
                // Вложенные промисы для каждого `id`
                const entityHistories = await Promise.all(
                    e.entity_ids.map(async (id) => {
                        const history = await this.getHistoryItems(e.entity, id);
                        return { id: e, histories: history };
                    })
                );
                histories.push(...entityHistories);
            });

            // Ожидание завершения всех промисов верхнего уровня
            await Promise.all(promises);

            return histories;
        }
    }
})

export interface Entity {
    entity: string, entity_ids: number[]
}

